import state from './moduleReserveState.js'
import mutations from './moduleReserveMutations.js'
import actions from './moduleReserveActions.js'
import getters from './moduleReserveGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
